export default {"src":"/_next/static/media/RheumatoidArthritisjhk.643fb084.svg","height":64,"width":51,"blurWidth":0,"blurHeight":0};